<template>
  <div class="policy">
    <div v-if="$route.params.policy == 'welcome'"></div>

    <div v-if="$route.params.policy == 'privacy'">
      
      <div class="policy-main">
        
        <h4>Política de Privacidade</h4>

        <h5>O que esta política cobre</h5>

        <p>
          Sua privacidade é importante para nós, bem como ser transparente sobre o que nós coletamos, 
          utilizamos, e compartilhamos sobre você. Esta política tem como objetivo lhe auxiliar a entender:
        </p>

        <ul>
          <li>Quais informações nós coletamos sobre você</li>
          <li>Como utilizamos a informação que coletamos</li>
          <li>Como compartilhamos a informação que coletamos</li>
          <li>Como armazenamos e asseguramos a informação coletada</li>
          <li>Como acessamos e controlamos a informação</li>          
          <li>Outras informações importantes a respeito de privacidade</li>
        </ul>

        <p>
          Esta política de privacidade cobre a informação que coletamos sobre você
          quando utiliza nossos serviços, ou interage conosco. "TARS" e "nós" se refere
          a TARSTECH DESENVOLVIMENTO DE TECNOLOGIAS LTDA. 
        </p>

        <p>
          Esta política também apresenta as suas escolhas a respeito de como usamos
          informações sobre você, nas quais incluem como você pode objetar a certos
          usos destas informações e como você pode acessar e atualizar determinadas
          informações sobre você. Se você não concorda com esta política, não acesse
          ou utilize os nossos serviços.
        </p>

        <p>
            Nas situações em que nós provermos o serviço para uma organização (por 
            exemplo, seu empregador) esta organização controla a informação processada
            pelos nossos serviços. Para mais informações, por favor, veja as notas
            para usuários abaixo. 
        </p>

        <h5>Quais informações nós coletamos de você</h5>

        <p>
          Nós coletamos informações sobre você quando você provê a informação a nós,
          quando você utiliza nossos serviços, e quando outras fontes nos fornecem,
          conforme descrito abaixo.
        </p>

        <h6>Informação que você nos provê</h6>

        <p>Nós coletamos informações sobre você quando você às insere nos nossos
          serviços ou quando você diretamente nos provê.
        </p>

        <p><b>Informações de conta e perfil:</b> Nós coletamos informações sobre você
        quando você se registra para uma conta, cria ou modifica um perfil, configura as suas
        preferências, realiza uma assinatura ou realiza compras por meio dos serviços. Por exemplo,
        você provê suas informações de contato e, em alguns casos, dados de cobrança, quando você 
        se registra para utilizar os Serviços. Você também tem a opção de adicionar um nome 
        para apresentação, foto de perfil, cargo, e outros detalhes para as suas informações
        de perfil para serem apresentadas em nossos Serviços. Nós mantemos registros das suas preferencias
        quando você às configura dentro de nossos Serviços.</p>

        <p><b>Conteúdo você fornece por meio de nossos produtos:</b> Os Serviços incluem os produtos
        TARS que você utiliza, onde nós coletamos e armazenamos o conteúdo que você posta, envia, recebe e compartilha.
        Este conteúdo inclui qualquer informação sobre você que você possa escolher incluir. Exemplos de conteúdos
        que nós coletamos e armazenamos incluem: o resumo e descrição adicionado a uma tarefa do Task,
        os nomes dos quadros no Task, os dados dos usuários que estejam cadastrados no Task ou 
        informações de anotações nas tarefas.</p>

        <p><b>Conteúdo você fornece por meio de nossos websites:</b> Os Serviços incluem também nossos
        websites onde nós somos proprietários ou operados por nós. Nós coletamos outros conteúdos que você possa
        submeter para estes websites, nos quais incluem mídias sociais ou websites de redes sociais operados por nós. Por exemplo, você provê conteúdo 
        para nós quando você fornece feedback ou quando envia um contato em nosso site institucional,
        ou quando você participa de qualquer interatividade, pesquisa, teste, promoções, atividades ou eventos.</p>

        <p><b>Informação que você fornece por meio de nossos canais de suporte:</b> Os Serviços também incluem
        nosso suporte ao cliente, onde você pode escolher submeter informações referentes a um problema
        que você possa estar experienciando com um Serviço. Quando você se designa a um contato
        técnico, abre um chamado de suporte, fala com um de nossos representantes diretamente ou
        de outra forma entra em contato com o time de suporte, você será solicitado a fornecer informações
        de contato, um resumo do problema que você está experienciando, e qualquer outra documentação,
        screenshots ou outra informação que possa ser de ajuda para resolver o problema.</p>

        <p><b>Informações de pagamento:</b> Nós coletamos informações de pagamento e cobrança quando 
        você se registra para serviços pagos. Por exemplo, nós solicitamos a você que indique as informações
        do responsável pelo pagamento, incluindo nome, informações de contato no momento do registro. Você pode também
        fornecer informações de pagamento, como detalhes de cartões de crédito para pagamento, nos quais nós coletamos 
        por meio de serviços seguros de processamento de pagamento.</p>

        <h6>Informação que nós coletamos automaticamente quando você utiliza os Serviços.</h6>

        <p>Nós coletamos informações sobre você quando você usa os nossos Serviços, incluindo navegação 
          nos nossos websites e ações dentro dos Serviços.
        </p>

        <p><b>Seu uso dos Serviços:</b>Nós mantemos o controle de certas informações sobre você quando você visita
        e interage com qualquer um de nossos Serviços. Estas informações incluem as funcionalidades que você utiliza;
        os links que você clica; os tipos, tamanhos e nomes de arquivos de anexos que você envia para os nossos Serviços; 
        termos pesquisados com frequência; o progresso do seu time no Task; e como você interage com outros nos Serviços. Nós
        também coletamos informações sobre os times e pessoas que trabalham com você e como você trabalha com elas, como por exemplo
        com quem você trabalha e se comunica com maior frequência.</p>

        <p><b>Dispositivos e Informação de Conexão:</b> Nós coletamos informação sobre o seu computador,
        telefone, tablet, ou outros dispositivos que você utiliza para acessar os Serviços. Estas informações de dispositivos
        incluem o tipo da conexão e configurações quando você acessa ou usa os nossos Serviços. Nós também coletamos informações 
        a respeito do seu dispositivo como o seu sistema operacional, tipo de navegador, endereço IP, URLs e identificação de dispositivos.
        Nós utilizamos o seu endereço IP para manter o controle se você realmente é quem está acessando nossos serviços ou se identificamos algum acesso suspeito.
        A quantidade de informações que nós coletamos depende do tipo e das configurações do dispositivo que você utiliza ao acessar os Serviços.</p>

        <h6>Informações que recebemos de outras fontes</h6>

        <p>Nós recebemos informaçõe ssobre você a partir de outros usuários do Serviço, a partir de serviços de terceiros, de empresas relacionadas à TARS, de 
          plataformas de mídia social, bancos de dados públicos, e de nossos canais e negócios parceiros. Nós podemos combinar estas informações com informações
          que nós coletamos por meio de outros meios descritos acima. Isto nos ajuda a atualizar e melhorar nossos registros, identificar novos clientes, criar 
          campanhas mais personalizadas e sugerir serviços que podem ser de seu interesse.
        </p>

        <h5>Quais informações nós coletamos de você</h5>

        <p>Como nós usamos a informação que coletamos depende de qual parte dos Serviços você utiliza, como você às utiliza, e quais as preferencias você pode
          ter nos comunicado. Abaixo são alguns propósitos específicos para os quais nós usamos a informação que coletamos sobre você.
        </p>

        <ul>
          <li>Para fornecer os Serviços e personalizar sua experiência</li>
          <li>Para pesquisa e desenvolvimento</li>
          <li>Para nos comunicarmos com você sobre os Serviços</li>
          <li>Para marketing, promoção e criar engajamento com os Serviços</li>
          <li>Suporte ao cliente</li>
          <li>Para segurança e proteção</li>
          <li>Para proteger nossos interesses comerciais legítimos e direitos legais</li>          
        </ul>

        <p><b>Com o seu consentimento:</b> Nós usamos informações sobre você onde você nos deu consentimento para 
        fazê-lo para um propósito específico não listado acima. Por exemplo, nós podemos publicar testemunhos
        ou estórias de clientes satisfeitos para promover nossos serviços, com a sua permissão.</p>

        <h5>Como nós compartilhamos informações que coletamos</h5>

        <p>Nós criamos ferramentas de colaboração, e nós queremos que elas funcionem melhor para você. Isto significa 
           compartilhar informação por meio dos Serviços. Nós compartihamos informações que coletamos sobre você nos meios abaixo. Nós
           não estamos no negócio de vendas de informações sobre você para anunciantes ou terceiros.
        </p>

        <h6>Compartilhar com outros usuários dos Serviços</h6>

        <p>Quando você utiliza os Serviços, nós compartilhamos certas informações sobre você com outros usuários dos Serviços.</p>

        <ul>
          <li>Para colaboração</li>
          <li>Gestão de contas e administradores</li>
        </ul>
        
        <h5>Como armazenamos e protegemos a informação que coletamos</h5>
        
        <h6>Armazenamento e proteção de informação</h6>

        <p>Nós usamos as técnicas padrões e medidas organizacionais para proteger a informação que armazenamos.</p>

        <p>Mesmo que implementemos proteções para garantir a segurança da sua informação, nenhum sistema de segurança é impenetrável e devido
          à natureza inerente da internet, nós não podemos garantir que esta informação, durante a transmissão da internet 
          ou enquanto armazenada em nossos sistemas ou sob nossos cuidados, é absolutamente protegida pela intrusão de outros.        
        </p>

        <p>
          Nós fortemente recomendamos que utilize senhas seguras, mantenha os seus dados de acesso somente para você e restrinja o acesso às informações
          para outros usuários por meio da tela de Administração de Perfis.
        </p>

        <h6>Por quanto tempo nós mantemos a informação </h6>

        <p>O quanto de tempo nós mantemos a informação que coletamos sobre você depende do tipo de informação. Depois de certo tempo,
          nós iremos deletar ou anonimizar a sua informação ou, se isto não for possível (por exemplo, porque a informação foi armazenada em arquivos de backup),
          então nós iremos de forma segura armazenar sua informação e isolá-la de qualquer outro uso até que a exclusão seja possível.
        </p>

        <h5>Como acessar e controlar sua informação</h5>

        <p>Você tem certos tipos de escolhas disponíveis quando se diz respeito a sua informação. Abaixo segue um resumo destas escolhas, como exercê-las e quaisquer limitações.</p>

        <h6>Suas escolhas:</h6>

        <p>Você tem o direito de requisitar a cópia das suas informações, de fazer objeção ao nosso uso da sua informação (incluindo para própositos comerciais), para requisitar a exclusão 
          ou restrição da sua informação, ou de requisitar a sua informação em uma forma eletrônicamente estruturada. Abaixo, nós descrevemos as ferramentas e processos para fazer estas 
          requisições. Você pode exercer algumas das escolhas entrando em contato com a equipe de atendimento ao cliente da TARS.
        </p>

        <p>Sua requisição e escolhas podem estar limitadas a certos casos: por exemplo, se cumprindo sua requisição revelaria informações sobre outras pessoas, ou se qualquer pedido de 
          exclusão de informação no qual nós  ou o seu administrador são permitidos por lei ou tem legítimo interesse em mantê-las. Se você tem preocupações não resolvidas, você tem o direito
          de recorrer a uma autoridade de proteção de dados, em um local onde você trabalha ou onde você sinta que os seus direitos foram infringidos.
        </p>

        <ul>
          <li>Acessar e atualizar sua informação</li>
          <li>Desativar sua conta</li>
          <li>Requisitar que nós paremos de utilizar suas informações</li>
          <li>Optar pela retirada de comunicações</li>
          <li>Desligar controles de cookies</li>
          <li>Portabilidade de dados</li>
        </ul>

        <h5>Outras informações importantes sobre privacidade</h5>

        <h6>Nota para usuários finais</h6>

        <p>Vários de nossos produtos tem intuito de serem utilizados por organizações. Quando os Serviços são disponibilizados 
          para você por meio de uma organização (por exemplo, sem empregador), esta organização é
          a administradora dos Serviços e é responsável pelas contas e/ou websites de Serviços que ela tem controle. Se este é o caso,
          por favor dirija suas questões a respeito de privacidade de dados para seu administrador, pois o seu uso dos Serviços diz respeito
          às políticas desta organização. Nós não somos responsáveis pela privacidade e práticas de proteção de um administrador de uma organização, que podem
          ser diferentes desta política.
        </p>

        <p>Os administradores podem:</p>

        <ul>
          <li>Requisitar que você resete a senha da sua conta;</li>
          <li>Restringir, suspender ou finalizar o seu acesso aos Serviços;</li>
          <li>Acessar informações sobre você e sobre sua conta;</li>
          <li>Acessar ou reter informações armazenadas como parte da sua conta;</li>          
        </ul>

        <p>Em alguns casos, administradores podem também:</p>

        <ul>
          <li>Resgtringir, suspender ou finalizar o seu acesso à sua conta;</li>
          <li>Mudar o e-mail associado à sua conta;</li>
          <li>Mudar suas informações, incluindo dados de perfil;</li>
          <li>Restringir sua permissão para editar, restringir, modificar ou excluir informações;</li>
        </ul>

        <h6>Nossa política a respeito de crianças</h6>

        <p>Os Serviços não são direcionados a indivíduos menores que 18 anos. Nós não coletamos intencionalmente
          dados pessoais de crianças menores que 18 anos. Se nós tivermos conhecimento que uma criança menor que 18
          nos forneceu dados pessoais, nós tomaremos as medidas para exclusão destas informações. Se você tomou 
          consciência que uma criança nos forneceu informações pessoais, por favo contate o suporte da TARS.
        </p>

        <h6>Mudanças na nossa Política de Privacidade</h6>

        <p>Nós podemos mudar esta política de privacidade de tempo em tempo. Nós iremos postar qualquer mudança 
        de política de privacidade nesta página e, se as mudanças forem significantes, nós iremos fornecer uma 
        nota mais proeminente em nossos websites, telas de login, ou enviando notificações por e-mail. Nós também iremos 
        manter as versões anteriores desta Política de Privacidade em um arquivo para sua revisão. Nós encorajamos que você revise
        nossa política de privacidade sempre que você utilizar os Serviços para se manter informado sobre as práticas de informações
        e as formas que você pode proteger a sua privacidade.</p>
      
        <p>Se você estiver em desacordo com quaisquer mudanças nesta política de privacidade, você irá precisar parar de utilizar os Serviços
          e desativar suas contas, conforme citado acima.
        </p>

        <h6>Entre em contato conosco</h6>

        <p>Sua informação é controlada pela Tarstech Desenvolvimento de Tecnologias LTDA. Se você tem dúvidas ou preocupações 
          sobre como sua informação é tratada, por favor dirija sua solicitação à Tarstech Desenvolvimento de Tecnologias LTDA, que é responsável
          e proprietária pelos Serviços.
        </p>

        <p>
          TARSTECH DESENVOLVIMENTO DE TECNOLOGIAS LTDA<br />
          pessoa jurídica do direito privado, inscrita no CNPJ/MF n° 33.116.822/0001-91
        </p>

        <p>
          Av. Ayrton Senna da Silva, nº 500, salas nº 06 e 07 <br />
          Gleba Fazenda Palhano, CEP 86.050-460, Londrina, Paraná <br />
          Brasil <br />
          E-mail: <b>meajuda@tars.com.br</b>
        </p>

      </div>
    </div>
      
    <div v-if="$route.params.policy == 'terms'" class="row">

      <div class="side-menu col-12 col-lg-3 p-0">

        <a
          v-on:click="evtScrollToPolicy('introduction')"
          v-bind:class="{ active: activeMenu == 'introduction' }"
        >Introdução</a>

        <a
          v-on:click="evtScrollToPolicy('relation')"
          v-bind:class="{ active: activeMenu == 'relation' }"
        >Seu relacionamento com a TARS</a>

        <a
          v-on:click="evtScrollToPolicy('term_object')"
          v-bind:class="{ active: activeMenu == 'term_object' }"
        >Termos gerais</a>

        <a
          v-on:click="evtScrollToPolicy('disagreement')"
          v-bind:class="{ active: activeMenu == 'disagreement' }"
        >Em caso de problemas ou discordâncias</a>

        <a
          v-on:click="evtScrollToPolicy('this_terms')"
          v-bind:class="{ active: activeMenu == 'this_terms' }"
        >Sobre estes termos</a>

      </div>

      <div class="policy-main col-12 col-lg-9">

        <h4 id="introduction">TERMOS DE SERVIÇO DO TARS ONE</h4>

        <p>Em vigor a partir de 17 de abril de 2020</p>

        <p>Nós atualizamos os Termos de Serviço em 17 de abril de 2020.</p>

        <p>
          Obrigado por utilizar o TARS One! Os Termos de Serviço descrevem os 
        seus direitos e responsabilidades como cliente do nosso produto TARS One. 
        Estes termos são entre você e a entidade TARS que é proprietária do produto 
        e serviços que são ofertados neste site.
        </p>

        <p><b>"Você"</b> significa a entidade na qual você representa ao aceitar os Termos ou,
        se isto não se aplica, você pessoalmente. Se você está aceitando em nome do
        seu empregador ou outra entidade, você representa e garante que: (i) você
        tem total autoridade legal para ligar o seu empregador a estes Termos; (ii) você
        leu e entendeu estes Termos; e (iii) você concorda com estes Termos em nome da
        parte que você representa. Se você não tem autoridade legal para representar
        o seu empregador ou entidade aplicável por favor, não clique em "Concordar e continuar"
        (ou botão similar) que lhe for apresentado. 
        </p>

        <p><b>
          POR FAVOR, NOTE QUE SE VOCÊ CRIAR UMA CONTA UTILIZANDO UM E-MAIL DO SEU EMPREGADOR
          OU OUTRA ENTIDADE, ENTÃO (A) VOCÊ SERÁ CONSIDERADO COMO REPRESENTANTE DESTA ENTIDADE, (B)
          SEU CLIQUE DE ACEITAÇÃO DOS TERMOS IRÁ LIGAR SEU EMPREGADOR OU ENTIDADE A ESTES TERMOS,
          E (C) A PALAVRA "VOCÊ" NESTES TERMOS IRÁ SE REFERIR AO SEU EMPREGADOR OU ENTIDADE.
        </b></p>

        <b><i>
          Estes termos são efetivos a partir da data em que você clicar em "Concordar e continuar" (ou botão 
          similar). Estes termos não precisam ser assinados fisicamente ou digitalmente para serem
          aceitos. Você indica que consente com estes termos clicando em "Concordar e continuar" 
          (ou botão similar) no momento da contratação do serviço.
        </i></b>

        <h5>O que estes termos cobrem</h5>

        <p>
          Estes termos de serviço incluem as seguintes seções:
        </p>

        <ul>
          <li><a href="#term_object">O objeto destes Termos</a>, que é o serviço que fornecemos.</li>
          <li><a href="#our_obligation">O que você pode esperar de nós</a>, que é o modo como fornecemos nossos serviços.</li>
          <li><a href="#your_obligation">O que esperamos de você</a>, que descreve e as regras estabelecidas para usar nossos serviços.</li>
          <li><a href="#disagreement">Em caso de problemas ou discordâncias</a>, que descreve outros direitos legais que você tem e o que esperar caso estes termos sejam violados.</li>
        </ul>

        <h5>Provedora de serviços</h5>

        <p>Os serviços da TARS que você contratar neste site são fornecidos por:</p>
        
        <p>
          TARSTECH DESENVOLVIMENTO DE TECNOLOGIAS LTDA<br />
          pessoa jurídica do direito privado, inscrita no CNPJ/MF n° 33.116.822/0001-91
        </p>

        <p>
          Av. Ayrton Senna da Silva, nº 500, salas nº 06 e 07 <br />
          Gleba Fazenda Palhano, CEP 86.050-460, Londrina, Paraná <br />
          Brasil
        </p>

        <h5 id="relation">Seu relacionamento com a TARS</h5>

        <p>
          Estes termos ajudam a definir o relacionamento entre você e a TARS. De modo geral
          permitimos que você use nossos serviços se concordar em seguir estes Termos. 
          Quando falamos de "TARS", "nós" "nosso" ou "nossa", estamos nos referindo a TARSTECH DESENVOLVIMENTO DE TECNOLOGIAS LTDA.
        </p>

        <h5 id="term_object">O objeto destes Termos</h5>

        <p>
          Estes Termos tem por objeto a concessão a você, sem caráter de
          exclusividade e intransferível, de licença de uso e acesso ao sistema TARS
          ONE, software de gestão que permite acesso a funcionalidades disponíveis na
          versão atualizada na data da contratação.
        </p>
        <p>
          Na versão atual disponível você terá acesso a funcionalidade TARS
          TASK, sistema de gerenciamento de processos e gestão de trabalho. A ferramenta
          permite o controle de horas de atividades, criação e compartilhamento de
          tarefas entre usuários e gestão de processos de clientes.
        </p>
        <p>
          O acesso ao SISTEMA se dará de forma online, através de uma URL,
          podendo esta ser modificada com prévio aviso.
        </p>
        <p>
          O SISTEMA objeto descrito nestes termos permite o Upload de arquivos, limitados a 10Gb
          por conta de acesso.
        </p>
        <p>
          Caso a quantidade seja excedida, será cobrado um valor
          adicional por Gigabyte armazenado, que será discriminado em fatura enviada a
          você.
        </p>
        <p>
          O SISTEMA de que trata o objeto destes Termos é de propriedade da TARS,
          sendo esta a única titular dos direitos autorais do mesmo.
        </p>
        <p>
          O SISTEMA será fornecido por meio eletrônico, sem mídias, para garantir que 
          você tenha sempre a versão mais atualizada.
        </p>
        <p>
          O aceite destes Termos, não se caracteriza como venda ou seção de
          direitos autorais, mas como licença de uso não exclusiva, conforme artigo 9º
          da Lei 9.609/1998 (Lei do Software) e não poderá ser transferida a quem quer
          que seja, sem consentimento prévio, expresso e específico por você.
        </p>

        <h5 id="our_obligation">O que você pode esperar de nós</h5>

        <p>
          A TARS se compromete a fornecer os acessos ao SISTEMA objeto destes Termos
          que se darão unicamente de forma online, assim como, a 
          prestar serviço de suporte.
        </p>
        <p>
          Nós manteremos suas informações ou seus dados em sigilo absoluto,
          ressalvada as hipóteses de determinação judicial ou inadimplemento contratual,
          que, neste último caso, as informações cadastrais serão encaminhadas aos
          órgãos de proteção ao crédito.
        </p>
        <p>
          Nós manteremos os devidos cuidados de guarda e
          conservação de qualquer dado disponibilizado por você, além de manter
          sigilo das informações que venha a ter acesso, desde o momento da entrega ou
          disponibilização dos sistemas, o qual somente poderá ser utilizado para
          fins destes Termos.
        </p>
        <p>
          Nós forneceremos suporte técnico à você, ou
          qualquer outro atendimento ou consulta, referente ao software, de
          segunda-feira à sexta-feira, das 08:00hs às 12:00hs e das 14:00hs às 18:00hs
          (horário de Brasília).
        </p>
        <p>
          Todas as instalações usadas para armazenar e processar dados os seus
          dados atenderão a padrões razoáveis de segurança não menos seguros que
          os padrões de segurança das instalações em que a TARS armazena e
          processa as próprias informações desse tipo. Como parte do fornecimento dos
          Serviços, a TARS pode transferir, armazenar e processar os seus Dados
          no território nacional. Ao usar os Serviços, você consente
          com a transferência, o processamento e o armazenamento de seus Dados.
        </p>
        <p>
          A TARS poderá disponibilizar novos aplicativos, recursos ou
          funcionalidades dos Serviços periodicamente, cujo uso pode depender da sua
          aceitação de termos adicionais.
        </p>
        <p>
          A TARS poderá fazer alterações comercialmente razoáveis nos Serviços
          periodicamente. Se fizer uma alteração relevante nos Serviços Principais, nós
          informararemos a você enviando um e-mail para o Endereço de
          E-mail de Notificação ou alertando pelo Admin console.
        </p>
        <p>
          Nós da TARS, estamos desobrigados de manter exclusividade em relação ao 
          software ou dos serviços de suporte com você ou a entidade que você representa, 
          em todo o território nacional, ou seja, não havendo qualquer restrição de 
          Município, Estado ou Região.
        </p>

        <h5 id="your_obligation">O que esperamos de você</h5>

        <p>
          Você deve se assegurar que todos os usos dos Serviços obedeçam a estes Termos
          por isso, leia atentamente os Termos descritos nesta página. A permissão que concedemos a você
          para usar nossos serviços permanecerá enquanto você cumprir suas responsabilidades definidas nestes Termos.
        </p>
        <p>
          Você deverá se comprometer e se responsabilizar a fornecer corretamente e
          o mais breve possível qualquer informação, dados pessoais, de cartão de
          crédito e jurídicos para cadastro solicitados pela TARS, independente de
          notificação, assumindo a responsabilidade pela sua omissão ou incorreta,
          irregular, imprecisa e equivocadas informações.
        </p>
        <p>
          A TARS se reserva ao direito de realizar guarda de dados
          informados pelo contratante para criação da conta do usuário, da compra e das
          parametrizações e configurações do serviço em si, para correta execução destes
          Termos. 
        </p>
        <p>
          Você e os usuários indicados obrigam-se a não acessar as
          áreas de programação do SISTEMA, seu banco de dados ou qualquer conjunto de
          informações que faça parte da atividade de programação, ficando sujeito quem o
          fizer à legislação penal brasileira e obrigado a reparar os danos que causar.
        </p>
        <p>
          Da mesma forma, você e os usuários indicados se comprometem a não
          realizar ou permitir engenharia reversa, nem traduzir, descompilar, copiar,
          modificar, reproduzir, alugar, sublicenciar, publicar, divulgar, transmitir,
          emprestar, distribuir ou, de outra maneira, dispor das ferramentas e das
          funcionalidades do SISTEMA.
        </p>      
        <p>
          Você deverá se comprometer em disponibilizar o meio adequado para a
          implantação e utilização do SISTEMA, tais como: hardware, rede, pessoas
          capacitadas, entre outros que se fizerem necessários e forem solicitados pela
          TARS.
        </p>
        <p>
          É de inteira responsabilidade sua o recolhimento de todos os
          impostos e encargos devidos incidentes na prestação dos serviços ora
          contratados, isentando a TARS de quaisquer responsabilidades
          civil, criminal, fiscal e tributária, entre outras.
        </p>
        <p>
          Você deverá se comprometer a fornecer todas as informações solicitadas
          por nós, sob pena desta, a seu critério exclusivo, interromper os
          serviços e/ou rescindir o presente Termo.
        </p>
        <p>
          Você e os respectivos usuários vinculados a sua conta principal assumem inteira
          responsabilidade pela guarda, sigilo e boa utilização do login e senhas
          cadastrados, isentando a TARS de qualquer responsabilidade.
        </p>
        <p>
          O login e Senha só poderão ser utilizados pelo usuário cadastrado a
          quem se referem, sendo expressamente proibido o compartilhamento de login e/ou
          Senha com quaisquer terceiros.
        </p>
        <p>
          Você poderá especificar, por meio do Admin console, um ou mais
          administradores que terão os direitos para acessar as Contas de Administrador
          e administrar as Contas de Usuário Final. Você também é responsável por: (a)
          manter a confidencialidade da senha e das Contas de administrador; (b)
          designar as pessoas que estão autorizadas a acessar as Contas de administrador
          e (c) garantir que todas as atividades relacionadas às Contas de administrador
          estejam em conformidade com o Contrato.
        </p>
        <p>
          Você fará esforços comercialmente razoáveis para impedir o uso
          não autorizado dos Serviços e encerrar qualquer uso não autorizado. Você se compromete
          notificar a TARS imediatamente sobre qualquer uso dos
          Serviços ou acesso não autorizado de que tenha conhecimento.
        </p>

        <h5 id="disagreement">Em caso de problemas ou discordâncias</h5>

        <p>
          A TARS se reserva o direito de suspender ou encerrar seu acesso aos serviços ou
          excluir sua Conta do One se alguma destas situações acontecer:
        </p>

        <ul>
          <li>Você violar estes Termos.</li>
          <li>Se precisarmos fazer isso para obedecer a um requisito legal ou uma ordem judicial.</li>
          <li>Se tivermos razões concretas para acreditar que sua conduta causa danos ou responsabilidade a um usuário, a terceiros ou a TARS,
            por exemplo, por meio de hacking, ludibriação de outras pessoas ou cópia de conteúdo que não pertença a você.
          </li>
        </ul>

        <p>
          Em caso de descumprimento das suas obrigações, você deverá 
          arcar com os prejuízos advindos da danificação permanente e irreparável 
          de banco de dados quando estes advierem por sua própria responsabilidade.
        </p>

        <h4 id="this_terms">Sobre estes termos</h4>

        <p>
          Por lei, você tem certos direitos que não podem ser limitados por um contrato como estes Termos de Serviço. Estes termos não têm, de forma alguma, o objetivo de restringir esses direitos.
        </p>

        <p>
          Estes termos descrevem a relação entre você e a TARS. Eles não geram nenhum direito legal para outras pessoas ou organizações, mesmo que elas se beneficiem desse relacionamento sob estes termos.
        </p>

        <p>
          Se você não seguir estes termos ou os termos adicionais específicos do serviço, e não tomarmos as medidas cabíveis imediatamente, isso não significa que estamos desistindo de quaisquer direitos que possamos ter, como tomar as medidas cabíveis futuramente.
        </p>

        <p>
          Podemos atualizar estes termos para refletir mudanças nos nossos serviços, por exemplo, quando adicionamos serviços, recursos, tecnologias, 
          preços ou benefícios novos (ou removemos os antigos), (2) por motivos jurídicos, regulatórios ou de segurança ou (3) para evitar abusos ou danos.
        </p>

        <p>
          Se fizermos mudanças significativas nestes termos, avisaremos com antecedência razoável e daremos a você oportunidade de analisar as mudanças, 
          exceto (1) quando lançarmos um novo serviço ou recurso ou (2) em situações urgentes, como para evitar abusos atuais ou responder a requisitos legais. 
          Se não concordar com os novos Termos, você deverá remover seu conteúdo e parar de usar os serviços. Você também pode finalizar seu relacionamento conosco 
          a qualquer momento encerrando sua Conta do One.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'policy',
  data: function () {
    return {
      activeMenu: ''
    }    
  },
  methods: {
    evtScrollToPolicy (policy) {
      this.activeMenu = policy
      $('#' + policy)[0].scrollIntoView({ behavior: 'smooth' })
    }
  }  
};
</script>

<style lang="scss">

.side-menu {

  display: flex;
  flex-direction: column;
  margin-top: 20px;
  position: fixed;

  a {    
    margin: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
  }

  a:hover, .active {      
    color: #3498db;
  }

}

.policy-main {

  height: calc(100% - 30px);
  overflow: auto;
  margin-top: 20px;
  margin-right: 20px;
  position: absolute;
  right: 0;
  padding: 20px;  

  p {
    font-size: 14px;
    line-height: 25px;
  }

  h4 {
    margin: 20px 0;
  }

  h5 {
    margin: 20px 0;
  }

  ul {
  font-size: 14px; 

    li {

      a {
        cursor: pointer;
        color: #3498db!important;
      }

    }

  }

}



</style>